/* import __COLOCATED_TEMPLATE__ from './connect-api.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type PulseAccordion } from 'glint/pulse';

interface Signature {
  Args: {
    customDescriptionKey?: string;
    accordion: PulseAccordion;
    onContinue: () => void;
  };
}

export default class ConnectApiComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get zendeskConfig() {
    return this.finStandaloneService.zendeskConfig;
  }

  get isConnected() {
    return !(this.zendeskConfig?.isPendingSetupForTickets ?? true);
  }

  @action
  continue() {
    if (this.args.onContinue) {
      this.args.onContinue();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Tickets::Integrate::ConnectApi': typeof ConnectApiComponent;
  }
}
